import demoConfig from './demo.config';
import localConfig from './local.config';
import prodConfig from './prod.config';
import testConfig from './test.config';
import uaConfig from './ua.config';

console.log(window.location.hostname)

let config = testConfig //change this to local when testing locally
if(window.location.hostname.includes('localhost')){
    config= localConfig;
}else if(window.location.hostname.includes('test')){
    config= testConfig;
}else if(window.location.hostname.includes('ua')){
    config= uaConfig;
}
else if(window.location.hostname.includes('demo')){
    config= demoConfig;
}
else if(window.location.href.includes('www.getreliable.com')){
    config= prodConfig;
}

export default config;